import React from "react";
import { IconButton, IconButtonProps, Box } from "@mui/material";

interface IconButtonBoxProps extends Omit<IconButtonProps, "children"> {
    icon: React.ReactNode; // 傳入的圖示
    text?: string; // 傳入的文字
    onClick: (...args: any[]) => void;
}

const IconButtonBox: React.FC<IconButtonBoxProps> = ({ icon, text, onClick }) => {
    return (
        <IconButton
            size="small"
            disableRipple
            className="icon-button no-ripple"
            onClick={onClick}
        >
            <Box className="icon-button-content">
                {icon}
                <span>{text}</span>
            </Box>
        </IconButton>

    );
};

export default IconButtonBox;
